import React from "react";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Divider from "@material-ui/core/Divider";
import LoanData from "../../../components/loanData";
import GuaranteeForChange from "../../../components/guaranteeForChange";

const BreakLoan = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TitlePage title="Tablero de Control \ Incumplimiento"/>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container spacing={2} justify="flex-end">
                            <Grid item>
                                <Button label="Regresar" onClick={props.handleReturnButton}
                                        className="p-button-secondary"/>
                            </Grid>
                            <Grid item>
                                <Button label="Incumplir" onClick={props.breakLoan}/>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <LoanData
                        ref={props.loanData}
                        loanId={props.loanId}
                        selectedLoan={props.selectedLoan}
                        loading={props.loading}
                    />
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <GuaranteeForChange
                        ref={props.guaranteeForChange}
                        loading={props.loading}
                        loanId={props.loanId}
                        loanType={props.selectedLoan.loanType}
                        updateGuaranteeTotal={props.updateGuaranteeTotal}
                        readOnly={true}
                        isPrecio24Hrs={true}
                    />
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default BreakLoan;